import { LayerInfoOverview } from "../../../types/LayerAdmin/LayerInfoOverview";
import { Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { ShrinkHeader } from "../../Table/ShrinkHeader";
import { TableContainer } from "../../../@ui/TableContainer";
import TableActionButton from "../../../@ui/TableActionButton";
import { useNavigate } from "react-router-dom";

interface LayerOverviewTableProps {
  overviews: LayerInfoOverview[];
}

const LayerOverviewTable = ({ overviews }: LayerOverviewTableProps) => {
  const navigate = useNavigate();

  const viewLayer = (selectedLayer: LayerInfoOverview) => {
    navigate(`/admin/layers/${selectedLayer.layerName}`);
  };
  return (
    <div className="w-100 h-100" style={{ overflow: "auto" }}>
      <Table bordered striped hover>
        <thead>
          <tr>
            <th className="bg-primary text-white">Name</th>
            <th className="bg-primary text-white">Last Import</th>
            <th className="bg-primary text-white">Concurrency Date</th>
            <ShrinkHeader className="bg-primary text-white" />
            {overviews?.filter((overview) => overview.oldData).length > 0 && (
              <ShrinkHeader className="bg-primary text-white" />
            )}
          </tr>
        </thead>
        <tbody>
          {overviews?.map((overview) => (
            <tr key={overview.layerName}>
              <td>{overview.layerName}</td>
              {overview.allowImport && (
                <>
                  <td>
                    {overview.lastImportDate
                      ? overview.lastImportDate.toFormat("dd-MM-yyyy")
                      : "-"}
                  </td>
                  <td>
                    {overview.concurrencyDate
                      ? overview.concurrencyDate.toFormat("dd-MM-yyyy")
                      : "-"}
                  </td>
                  <td>
                    <div className="d-flex flex-row align-items-center justify-content-center">
                      <TableActionButton
                        onClick={() => viewLayer(overview)}
                        title="View layer">
                        View
                      </TableActionButton>
                    </div>
                  </td>
                  <td>
                    {overview.oldData && (
                      <div className="w-100 h-100 d-flex flex-row align-items-center justify-content-center">
                        <FontAwesomeIcon
                          color="orange"
                          size="xl"
                          icon={faWarning}
                        />
                      </div>
                    )}
                  </td>
                </>
              )}
              {!overview.allowImport && (
                <td colSpan={4} className="text-danger">
                  Import not allowed on this environment
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default LayerOverviewTable;
